import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { EmptyState, TextButton } from '@wix/design-system';
import { Refresh, StatusAlert } from '@wix/wix-ui-icons-common';

type Props = {
  onTryAgain: () => void;
};

export const SiteSetupStepErrorState: FC<Props> = ({ onTryAgain }) => {
  const { t } = useTranslation();

  return (
    <EmptyState
      skin="page"
      title={t('site-setup-step.error.title')}
      subtitle={t('site-setup-step.error.subtitle')}
      image={<StatusAlert />}
    >
      <TextButton onClick={onTryAgain} prefixIcon={<Refresh />}>
        {t('site-setup-step.error.button')}
      </TextButton>
    </EmptyState>
  );
};
